import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  Select,
  FormControl,
  MenuItem,
  TextField,
  Button,
} from '@material-ui/core'
import ROUTES from '../../../../routers/routes'
import { useHistory } from 'react-router-dom'
import {
  getMipymesWorkshop,
  verifyMipymeAndWorkshop,
  verifyWorkshopAttempts,
} from '../../../../services/Elegibilidad/get'
import { useAuthentication } from '../../../../context/authenticationContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import { createTestWorkshop } from '../../../../services/Elegibilidad/create'
import Swal from 'sweetalert2'

export const ModalWorkshop = ({ open, setOpen }) => {
  const history = useHistory()
  const { userIDB2C } = useAuthentication()
  const [mipymes, setMipymes] = useState([])

  const GeneralDataSchema = Yup.object().shape({
    CodWorkshop: Yup.string().required('Este campo es obligatorio'),
    IdMiPyme: Yup.number().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      IdMiPyme: '',
      CodWorkshop: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      handleToWorkshop(values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleToWorkshop = async (values) => {
    try {
      const response = await verifyMipymeAndWorkshop(values)
      if (response.Success) {
        if (response.Data) {
          validateWorkshop()
        } else {
          swal({
            title: 'Código de Taller Inicial incorrecto.',
            icon: 'error',
            button: 'Entendido',
          })
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Función para obtener las mipymes
  const getMipymes = async () => {
    try {
      const response = await getMipymesWorkshop(userIDB2C)
      if (response.Success) {
        setMipymes(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getMipymes()
  }, [open])

  const validateWorkshop = async () => {
    try {
      const response = await verifyWorkshopAttempts(formik.values.CodWorkshop)
      if (response.Success) {
        if (response.Message === 'Nuevo' || response.Data) createTest()
        else {
          if (response.Message === 'Reprobado')
            Swal.fire({
              title: `<h4>El Taller Inicial con código ${formik.values.CodWorkshop} tiene el estado de Reprobado.
            
            Para repetir la prueba solicite un nuevo código a comunicacionescambio@bcie.org</h4>`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#3085d6',
            })
          else {
            Swal.fire({
              title: `<h4>El Taller Inicial con código ${formik.values.CodWorkshop} tiene el estado de Aprobado.`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#3085d6',
            })
          }
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Funcion para crear el  test
  const createTest = async () => {
    try {
      const response = await createTestWorkshop(formik.values.CodWorkshop)
      if (response.Success) {
        formik.resetForm()
        setOpen(false)
        history.push(ROUTES.WORKSHOP.pathname, {
          idTest: response.Data,
          codWorkshop: formik.values.CodWorkshop,
        })
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setMipymes([])
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="pymeDiv">
            <h1 className="pymeTitle">Activación de Taller Inicial</h1>
          </div>

          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <label className="responsiveLabel">MIPYME</label>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <FormControl fullWidth>
                    <Select
                      id="IdProject"
                      name="IdProject"
                      variant="outlined"
                      // displayEmpty={true}
                      onChange={(e) => {
                        formik.setFieldValue('IdMiPyme', e.target.value)
                      }}
                      error={formik.errors.IdMiPyme}
                      // renderValue={
                      //   formik.values.IdMiPyme !== ''
                      //     ? undefined
                      //     : () => 'Seleccione una opción'
                      // }
                    >
                      <MenuItem disabled value="">
                        Seleccione una opción
                      </MenuItem>
                      {mipymes &&
                        mipymes.map((item, key) => (
                          <MenuItem key={key} value={item.IdMiPyme}>
                            {/* {item.BusinessName} */}
                            {item.TaxRegistration} - {item.BusinessName}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.errors.IdMiPyme ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.IdMiPyme}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  marginTop: '3%',
                }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <label className="responsiveLabel">Código</label>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                  <FormControl fullWidth>
                    <TextField
                      id="userName"
                      style={{ width: '100%' }}
                      placeholder="Ingrese código"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('CodWorkshop', e.target.value)
                      }}
                      value={formik.values.CodWorkshop}
                      error={formik.errors.CodWorkshop}
                    />
                    {formik.errors.CodWorkshop ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.CodWorkshop}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => setOpen()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                >
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
